import { differenceInMilliseconds } from 'date-fns'
import { recoverTokens } from 'data/tokenStore'
import { periodicRenewToken } from 'data/auth/actions'
import periodically from 'components/Utils/hoc/periodically'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const ONE_MINUTE = 60 * 1000 // 60 seconds
const RENEW_EVERY_X_HOURS = 2

export function TokenRenewer({ children }) {
  return children
}

export default compose(
  connect(
    null,
    { periodicRenewToken }
  ),
  periodically({
    heading: false,
    interval: ONE_MINUTE,
    fn: function tokenRenewalChecker(props) {
      const tokens = recoverTokens()
      const { periodicRenewToken } = props

      if (tokens) {
        const differenceInHours =
          differenceInMilliseconds(Date.now(), new Date(tokens.at)) /
          (60 * 60 * 1000) // 1 hour

        if (differenceInHours > RENEW_EVERY_X_HOURS) {
          periodicRenewToken({ tokens })
        }
      }
    },
  })
)(TokenRenewer)
